<template>
  <div>
    <v-dialog
      v-model="dialogRecovery"
      scrollable
      max-width="800"
      style="width: 100%"
      persistent
      lazy
    >
      <template slot="activator">
        <v-btn color="primary" dark small block :loading="loading">
          {{ $t('action.actions.recoverVideo') }}
        </v-btn>
      </template>
      <v-card>
        <v-toolbar color="primary" flat dense card dark>
          <v-toolbar-title>
            {{ $t('action.actions.recoverVideo') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex md6 xs12 px-2>
              <v-menu
                ref="menuFrom"
                v-model="menuFrom"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="fromTime"
                    v-validate="{ required: true }"
                    prepend-icon="access_time"
                    readonly
                    :label="$tc('fields.global.startAtTime') + ' (*)'"
                    :data-vv-name="$tc('fields.global.startAtTime')"
                    :error-messages="
                      errors.collect($tc('fields.global.startAtTime'))
                    "
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menuFrom"
                  v-model="fromTime"
                  full-width
                  format="24hr"
                  @click:minute="$refs.menuFrom.save(fromTime)"
                />
              </v-menu>
            </v-flex>
            <v-flex md6 xs12 px-2>
              <v-menu
                ref="menuTo"
                v-model="menuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="toTime"
                    v-validate="{ required: true }"
                    prepend-icon="access_time"
                    readonly
                    :label="$tc('fields.global.endAtTime') + ' (*)'"
                    :data-vv-name="$tc('fields.global.endAtTime')"
                    :error-messages="
                      errors.collect($tc('fields.global.endAtTime'))
                    "
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menuTo"
                  v-model="toTime"
                  full-width
                  format="24hr"
                  @click:minute="$refs.menuTo.save(toTime)"
                />
              </v-menu>
            </v-flex>
            <v-flex xs12 px-2>
              <v-subheader class="pl-0">
                {{ $t('titles.matches.advanceOrDelay') }}
              </v-subheader>
              <v-slider
                v-model="timeDiff"
                min="-120"
                max="120"
                thumb-label="always"
                thumb-size="24"
                @change="onTimeDiff"
              />
            </v-flex>

            <v-flex v-if="url" xs12 px-2>
              <v-card flat>
                <v-layout fill-height align-center justify-center ma-0>
                  <video :src="url" controls style="max-width: 100%" />
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />

          <template>
            <meta-button type="reset" :disabled="loading" @click="clear" />

            <meta-button type="cancel" @click="cancel" />
            <v-btn
              small
              :loading="loading"
              color="primary"
              @click="_getBackUpVideo"
            >
              {{ $t('action.buttons.getVideo') }}
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirm" max-width="600" lazy persistent>
      <v-card>
        <v-toolbar color="primary" flat dense card dark>
          <v-toolbar-title>
            {{ $t('titles.global.confirmation') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <span class="subheading">{{ confirmVideoMessage }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small color="primary" @click="confirmOverride">
            {{ $t('action.buttons.confirm') }}
          </v-btn>
          <meta-button type="cancel" @click="cancel" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { mapActions } from 'vuex'

export default {
  name: 'DialogRecoveryVideo',
  components: {},
  props: {
    objectId: {
      type: String,
      required: true,
    },
    stadiumId: {
      type: String,
      required: true,
    },
    location: {
      type: String,
      required: true,
    },
    camera: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    time: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      default: 90,
    },

    videoExist: {
      type: Object,
      required: false,
      default: null,
    },
    typeVideo: {
      type: String,
      required: false,
      default: 'match',
    },
  },
  data() {
    return {
      timeDiff: 0,
      dialogRecovery: false,
      dialogConfirm: false,
      loading: false,
      menuFrom: false,
      menuTo: false,
      fromTime: '',
      toTime: '',
      rbpiId: '',
      url: '',
      path: '',
    }
  },

  computed: {
    confirmVideoMessage() {
      if (this.typeVideo == 'training')
        return this.$t('titles.matches.confirmTrainingVideo')
      else return this.$t('titles.matches.confirmMatchVideo')
    },
  },
  methods: {
    ...mapActions({
      getBackUpVideo: 'rbpi/getBackUpVideo',
    }),
    formatTime(time) {
      const [hour, minute] = time.split(':')

      return moment(moment(this.date).format('YYYY-MM-DD'))
        .tz('Europe/Madrid')
        .set({ hour, minute })
        .toISOString()
    },
    async _getBackUpVideo() {
      const valid = await this.validate()
      if (!valid) return
      try {
        const params = {
          startAt: this.formatTime(this.fromTime),
          endAt: this.formatTime(this.toTime),
          type: this.typeVideo,
          objectId: this.objectId,
          camera: this.camera,
          location: this.location,
        }
        this.loading = true
        await this.getBackUpVideo(params)
        this.cancel()
      } catch (error) {
        // this.cancel()
      } finally {
        this.cancel()
        this.loading = false
      }
    },

    checkIfVideoExists() {
      if (this.videoExist) {
        this.nextTick(() => {
          this.dialogConfirm = true
        })
      } else {
        this.dialogRecovery = true
      }
    },
    confirmOverride() {
      this.dialogRecovery = true
      this.dialogConfirm = false
    },
    onTimeDiff(timeDiff) {
      const [hour, minute] = this.time.split(':')
      const fromTime = moment().set({ hour, minute, second: 0 })
      this.fromTime = fromTime.add(timeDiff - 5, 'minutes').format('HH:mm')
      this.toTime = fromTime.add(this.duration + 10, 'minutes').format('HH:mm')
    },
    clear() {
      this.$validator.pause()
      this.nextTick(() => {
        this.fromTime = ''
        this.toTime = ''
        this.rbpiId = ''
        this.url = ''
        this.path = ''
        this.timeDiff = 0
        this.dialogConfirm = false
        this.$validator.reset()
        this.$validator.resume()
      })
    },
    cancel() {
      this.dialogRecovery = false
      this.clear()
    },
  },
  watch: {
    dialogRecovery(val) {
      if (val) {
        this.onTimeDiff(0)
      }
    },
  },
}
</script>
